import classnames from 'classnames'
import { type IColumn } from 'shared/ui'
import { NumbersStatus } from 'entities/Phone/ui/NumbersStatus/NumbersStatus'
import { type RowNumber } from 'entities/Phone/model/Table/RowNumber'
import styles from './styles.module.scss'

export const statusCell: IColumn<RowNumber> = {
  field: 'status',
  name: 'Status',
  isSortable: true,
  renderRowCell: (row) => {
    const { disabled } = row
    const { status } = row.origin

    return (
      <div
        className={classnames(styles.statusCell, {
          [styles.statusCell__block]: disabled,
        })}
      >
        <NumbersStatus status={status || ''} />
      </div>
    )
  },
}
